import * as React from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';

export const SupportLink = ({url}) => {
  const link = url || '#';
  const href = link.indexOf('@') > 0 ?  `mailto:${url}` : link;
  return (
    <a href={href} className="standalone-link">
        {url}
        <MdKeyboardArrowRight className="standalone-link-arrow"/>
    </a>);
};
